import React, { useState } from "react";
import { useI18n } from "@/coquille-bridge";

/**
 * Formulaire demande de compte aligné DojoOS — champs étendus Phase 1.
 */
export function KarateAccountRequestForm({ roleOptions = [], onSubmit, testId = "karate-account-request-form" }) {
  const { lang } = useI18n();
  const locale = lang === "en" ? "en" : "fr";
  const [childName, setChildName] = useState("");
  const [selectedRole, setSelectedRole] = useState(roleOptions[0]?.value || "student");

  const labels =
    locale === "en"
      ? {
          name: "Full name",
          email: "Email",
          phone: "Phone (optional)",
          role: "Requested role",
          org: "Preferred dojo",
          child: "Child name (if parent)",
          message: "Message",
          submit: "Submit request",
          demo: "Local demo — request stored in browser only.",
        }
      : {
          name: "Nom complet",
          email: "Courriel",
          phone: "Téléphone (optionnel)",
          role: "Rôle demandé",
          org: "Dojo souhaité",
          child: "Nom de l'enfant (si parent)",
          message: "Message",
          submit: "Envoyer la demande",
          demo: "Démo locale — demande enregistrée dans le navigateur uniquement.",
        };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    onSubmit?.({
      name: fd.get("name"),
      email: fd.get("email"),
      phone: fd.get("phone"),
      role: fd.get("role"),
      organization: fd.get("organization"),
      childName: fd.get("childName"),
      message: fd.get("message"),
    });
  };

  return (
    <form className="gsd-account-request-form karate-account-request-form" onSubmit={handleSubmit} data-testid={testId}>
      <p className="muted" data-testid="account-request-demo-notice">{labels.demo}</p>
      <label>
        {labels.name}
        <input name="name" required data-testid="karate-account-request-name" />
      </label>
      <label>
        {labels.email}
        <input name="email" type="email" required data-testid="karate-account-request-email" />
      </label>
      <label>
        {labels.phone}
        <input name="phone" type="tel" data-testid="karate-account-request-phone" />
      </label>
      <label>
        {labels.role}
        <select
          name="role"
          required
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
          data-testid="karate-account-request-role"
        >
          {roleOptions.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </label>
      <label>
        {labels.org}
        <input name="organization" placeholder="[DÉMO] Emplacement dojo 1" data-testid="karate-account-request-org" />
      </label>
      {selectedRole === "parent" ? (
        <label>
          {labels.child}
          <input name="childName" value={childName} onChange={(e) => setChildName(e.target.value)} data-testid="karate-account-request-child" />
        </label>
      ) : (
        <input type="hidden" name="childName" value="" />
      )}
      <label>
        {labels.message}
        <textarea name="message" rows={4} data-testid="karate-account-request-message" />
      </label>
      <button type="submit" className="gsd-account-request-form__submit" data-testid="karate-account-request-submit">
        {labels.submit}
      </button>
    </form>
  );
}
